
import store from '@/store';
import TrainingProgressCircle from '@/components/TrainingProgressCircle.vue';
import TrainingHelper from '@/views/CandidateApp/TrainingHelper';

export default {
  name: 'TrainingProgressRow',

  components: {
    TrainingProgressCircle,
  },
  props: {
    mode: {
      type: String,
      default: '',
    },

    name: {
      type: String,
      default: '',
    },
    progressPercentage: {
      type: Number,
      default: 0,
    },
    percentage: {
      type: Number,
      default: 0,
    },
    imgUrl: {
      type: String,
      default: '',
    },
    status: {
      type: String,
      default: '',
    },
    tasksView: Boolean,
    date: {
      type: String,
      default: '',
    },
    id: {
      type: String,
      default: '',
    },
    deadline: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    trainingSessions: {
      type: Array,
      default: (): unknown[] => [],
    },
    sourceFiles: {
      type: Array,
      default: (): unknown[] => [],
    },
    trainers: {
      type: Array,
      default: (): unknown[] => [],
    },
    address: {
      type: Object,
      default: (): Record<string, never> => ({}),
    },
    stage: {
      type: String,
      default: '',
    },
    rejectedBy: {
      type: Object,
      default: (): Record<string, never> => ({}),
    },
    accepted: Boolean,
    attended: Boolean,
    results: {
      type: Array,
      default: (): unknown[] => [],
    },
    trainingId: {
      type: String,
      default: '',
    },
    tasks: {
      type: Array,
      default: (): unknown[] => [],
    },
  },
  data(): Record<string, unknown> {
    return {
      device: store.state.device,
      userRole: store.state.userRole,
      applyProjectRowFocusClass: false,
      visitedStyle: false,
      eventHighlightedClassName: '',
      openTrainingsModal: false,
      modalOpened: false,
      clearTaskFile: false,
      trainingColorMap: {},
      trainings: [],
      parseTrainingData: TrainingHelper.parseTrainingData,
    };
  },
  computed: {
    currentSessions(): Record<string, any> {
      return store.state.trainingSessions;
    },

    trainingsRequestPending(): boolean {
      return store.state.trainingsRequestPending;
    },

    trainingSessionsRequestPending(): boolean {
      return store.state.trainingSessionsRequestPending;
    },

    tasksRequestPending(): boolean {
      return store.state.tasksRequestPending;
    },
    sessionsRequestPending(): boolean {
      return store.state.sessionsRequestPending;
    },
  },
  watch: {
    trainingsRequestPending(newVal: unknown): void {
      if (!newVal) {
        setTimeout(() => {
          this.focusOnProjectIfNeeded();
        }, 200);
      }
    },

    trainingSessionsRequestPending(newVal: unknown): void {
      if (!newVal) {
        setTimeout(() => {
          this.focusOnProjectIfNeeded();
        }, 200);
      }
    },
    sessionsRequestPending(newVal: unknown): void {
      if (!newVal) {
        setTimeout(() => {
          this.focusOnProjectIfNeeded();
        }, 200);
      }
    },
    tasksRequestPending(newVal: unknown): void {
      if (!newVal) {
        setTimeout(() => {
          this.focusOnProjectIfNeeded();
        }, 200);
      }
    },
  },
  created(): void {
    if (
      this.mode === 'trainings' ||
      this.mode === 'upcoming' ||
      this.mode === 'tasks' ||
      this.mode === 'sessions'
    ) {
      this.eventHighlightedClassName = 'event--transparent';
    }
  },

  mounted(): void {
    if (!this.trainingsRequestPending) {
      setTimeout(() => {
        this.focusOnProjectIfNeeded();
      });
    }
    if (!this.trainingSessionsRequestPending) {
      setTimeout(() => {
        this.focusOnProjectIfNeeded();
      });
    }
    if (!this.tasksRequestPending) {
      setTimeout(() => {
        this.focusOnProjectIfNeeded();
      });
    }
  },
  beforeDestroy(): void {
    clearInterval(this.timer);
  },

  methods: {
    truncateName(name, length): string {
      if (!name) return '';
      if (name.length <= length) return name;
      return name.slice(0, length) + '...';
    },
    getEventClass(): Record<string, unknown> {
      let cssClass;

      if (this.isAuthorizedAssessorACoAssessor) {
        cssClass = {};
        cssClass['event--co-assessor'] = true;
        return cssClass;
      }
      if (this.mode === 'projects')
        cssClass = {
          'assessment-progress-row--initial-highlight': this.applyProjectRowFocusClass,
          'event--transparent': this.visitedStyle,
          'event--green': this.userWhoCreated === 'client',
          'event--light--green': this.userWhoCreated === 'assessor',
        };
      if (this.mode === 'interviews' && this.tasksView)
        cssClass = {
          'assessment-progress-row--initial-highlight': this.applyProjectRowFocusClass,
          'event--blue': this.visitedStyle,
          'event--dark--blue': this.userWhoCreated === 'client',
          'event--light--blue': this.userWhoCreated === 'assessor',
        };
      if (this.mode === 'reports')
        cssClass = {
          'assessment-progress-row--initial-highlight': this.applyProjectRowFocusClass,
          'event--blue': this.visitedStyle,
          'event--dark--blue': this.userWhoCreated === 'client',
          'event--light--blue': this.userWhoCreated === 'assessor',
        };
    },

    emitActiveTrainingId(): void {
      this.$emit('active-training-id', this.id);
    },

    getTrainingColor(trainingId: string): Promise<string> {
      this.trainings = store.state.candidateTrainings;
      const index = this.trainings.findIndex((training) => training.id === trainingId);
      if (index !== -1) {
        return this.generateColor(index);
      }
    },
    generateColor(index: number): string {
      const colorMap = {
        0: '#87eab0',
        1: '#82b2e5',
        2: '#f2ec9d',
        3: '#f2b58f',
        4: '#82b2e5',
      };
      return colorMap[index] || '#ad7474';
    },
    canUploadFiles(status, accepted, attended, stage): boolean {
      return (
        (stage === 'pre_work' && accepted === true && status !== 'accepted') ||
        (stage === 'post_work' && accepted === true && status !== 'accepted') ||
        (stage === 'training' && attended === true && status !== 'accepted') ||
        status === 'missed' ||
        status === 'rejected'
      );
    },

    emitOpenModal(): void {
      if (this.modalCanBeOpened) {
        store.commit('setModalOpen', true);
        this.$emit('openModal');
      }
      if (this.mode === 'upcoming' || this.mode === 'sessions') {
        store.commit('setModalOpen', true);
        this.$emit('openTrainingModal');
      }
      if (this.mode === 'tasks') {
        this.$emit('openTaskModal');
        store.commit('setModalOpen', true);
      }
    },
    focusOnProjectIfNeeded(): void {
      if (
        (store.state.trainingsModeFilter.activeMode === 'trainings' ||
          store.state.trainingsModeFilter.activeMode === 'upcoming' ||
          store.state.trainingsModeFilter.activeMode === 'tasks') &&
        store.state.recentlyEditedProjectId === this.id
      ) {
        this.applyProjectRowFocusClass = true;

        const topOfRow = this.$refs.assessmentProgressRow.getBoundingClientRect().top;
        scrollTo(0, topOfRow);

        store.commit('setRecentlyEditedProjectId', undefined);

        this.applyVisitedStyle();
      }
    },

    applyVisitedStyle(): void {
      // first remove recently applied style
      const lastVisitedItem = document.querySelector(`.${this.eventHighlightedClassName}`);
      const shouldNotApply =
        !lastVisitedItem ||
        (this.visitedStyle && this.$vnode.elm.className.includes(this.eventHighlightedClassName));

      if (shouldNotApply) return;

      lastVisitedItem.classList.remove(this.eventHighlightedClassName);

      this.visitedStyle = false;

      setTimeout(() => {
        this.visitedStyle = true;
      });
    },

    makeActionOnClick(): void {
      if (this.mode === 'trainings') {
        this.emitActiveTrainingId();
      } else {
        this.emitOpenModal();
      }
    },
  },
};
